import React from 'react';

const ImageSkeleton: React.FC = () => {
    return (
        <div className="image-skeleton">
            <div className="skeleton-image"></div>
        </div>
    );
};

export default ImageSkeleton;